import { createComponent } from '@carvana/merch-components';
import { ReactNode } from 'react';

/**
 * Shared styled components for FeatureBranch
 * These components provide consistent dark mode styling across all FeatureBranch views
 */

// Form Elements
export const Select = createComponent('select', {
  className:
    'w-full rounded-md border border-gray-600 bg-gray-800 px-md py-md text-white focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500',
  style: {
    fontSize: '16px',
    minHeight: '44px'
  }
});

export const Input = createComponent('input', {
  className:
    'w-full rounded-md border border-gray-600 bg-gray-800 px-md py-sm text-white placeholder-gray-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500'
});

export const Textarea = createComponent('textarea', {
  className:
    'w-full rounded-md border border-gray-600 bg-gray-800 px-md py-sm text-white placeholder-gray-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500'
});

// Labels
export const Label = createComponent('label', {
  className: 'mb-sm block text-gray-300 t-body-sm'
});

export const HelperText = createComponent('p', {
  className: 'mt-sm text-gray-400 t-body-xs'
});

// Headings
export const Heading = createComponent('h3', {
  className: 'text-white t-heading-xs'
});

// Buttons
export const Button = createComponent('button', {
  className:
    'rounded-md bg-blue-600 px-lg py-md text-white t-label-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-50'
});

export const SecondaryButton = createComponent('button', {
  className:
    'rounded-md bg-gray-600 px-lg py-sm text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 disabled:cursor-not-allowed disabled:opacity-50'
});

export const SmallSecondaryButton = createComponent('button', {
  className:
    'rounded-md bg-gray-600 px-sm py-xs text-xs text-white hover:bg-gray-700'
});

// Containers
export const Container = createComponent('div', {
  className: 'flex flex-col gap-lg'
});

export const ResultsContainer = createComponent('div', {
  className:
    'bg-gray-900/30 max-h-[400px] overflow-y-auto rounded-md border border-gray-700 p-md'
});

export const ResultItem = createComponent('div', {
  className: 'mb-md border-b border-gray-700 pb-md last:border-b-0'
});

export const Card = createComponent('div', {
  className: 'bg-gray-800/50 rounded-xs p-sm t-body-xs'
});

// Text Elements
export const Text = createComponent('div', {
  className: 'text-gray-300 t-body-sm'
});

export const TextStrong = createComponent('strong', {
  className: 'text-white'
});

// Error Message
type ErrorMessageProps = {
  children: ReactNode;
};

export function ErrorMessage({ children }: ErrorMessageProps) {
  return (
    <div
      className="bg-red-900/20 rounded-md border border-red-700 px-md py-sm text-red-300 t-body-sm"
      role="alert"
    >
      {children}
    </div>
  );
}
